import { api_host, api_auth } from '../../common/globals/constants';

export const FLINDEX_CONFIG_CHANGED_EVENT = 'flindex-config-changed';
export const FLINDEX_CONFIG_STORAGE_KEY = 'flindex-config-changed';
const FLINDEX_CONFIG_REV_PREFIX = 'flindex-config-rev:';

/** Revisión local: invalida caché HTTP del navegador tras guardar config FLINDEX. */
export function getFlindexConfigRevision(objectiveId) {
  try {
    return sessionStorage.getItem(`${FLINDEX_CONFIG_REV_PREFIX}${objectiveId}`) || '0';
  } catch (e) {
    return '0';
  }
}

export function bumpFlindexConfigRevision(objectiveId) {
  const rev = String(Date.now());
  try {
    sessionStorage.setItem(`${FLINDEX_CONFIG_REV_PREFIX}${objectiveId}`, rev);
  } catch (e) {
    // private mode / quota
  }
  return rev;
}

/** Normaliza indicador API/DB (MAYÚSCULAS o snake_case) al shape del formulario. */
export function normalizeFlindexIndicador(raw) {
  if (raw == null) return null;
  let indicador = raw;
  if (typeof raw === 'string') {
    try {
      indicador = JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }
  if (typeof indicador !== 'object') return null;

  const pick = (upper, lower) => {
    if (indicador[upper] !== undefined && indicador[upper] !== null) return indicador[upper];
    if (indicador[lower] !== undefined && indicador[lower] !== null) return indicador[lower];
    return undefined;
  };

  const normalized = {
    C: pick('C', 'c_factor'),
    MIN_EVENTOS: pick('MIN_EVENTOS', 'min_eventos'),
    MAX_EVENTOS: pick('MAX_EVENTOS', 'max_eventos'),
    MAX_VENTANA_MINUTOS: pick('MAX_VENTANA_MINUTOS', 'max_ventana_minutos'),
    UMBRAL_SEGMENTO_FINO_MIN: pick('UMBRAL_SEGMENTO_FINO_MIN', 'umbral_segmento_fino_min'),
    ACCION_SEGMENTO_FINO: pick('ACCION_SEGMENTO_FINO', 'accion_segmento_fino'),
  };

  const hasAny = Object.values(normalized).some((v) => v !== undefined);
  return hasAny ? normalized : null;
}

/** Huella de la config usada en el último cálculo FLINDEX (respuesta API). */
export function flindexConfigFingerprint(config) {
  if (!config) return '';
  return JSON.stringify({
    c_factor: config.c_factor,
    min_eventos: config.min_eventos,
    max_eventos: config.max_eventos,
    max_ventana_minutos: config.max_ventana_minutos,
    umbral_segmento_fino_min: config.umbral_segmento_fino_min,
    accion_segmento_fino: config.accion_segmento_fino,
    source: config.source,
  });
}

/** Avisar al gráfico Online que debe volver a pedir FLINDEX para ese objetivo. */
export function notifyFlindexConfigChanged(objectiveId) {
  bumpFlindexConfigRevision(objectiveId);
  const detail = { objetivoId: String(objectiveId), ts: Date.now() };
  window.dispatchEvent(new CustomEvent(FLINDEX_CONFIG_CHANGED_EVENT, { detail }));
  try {
    localStorage.setItem(FLINDEX_CONFIG_STORAGE_KEY, JSON.stringify(detail));
  } catch (e) {
    // quota / private mode
  }
}

const flindexFetchOpts = { cache: 'no-store' };

function flindexConfigRevParam(objectiveId) {
  return `&configRev=${encodeURIComponent(getFlindexConfigRevision(objectiveId))}`;
}

export const getFlindex = (user, objetivo_id, period, node, token, includeNodes = 0) =>
fetch(
  api_host
    + `/reporte/online/indicadores/getFlindex/?user=${user}&usuarioId=${user}&key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${period}&token=${token}&nodoId=${node}&includeNodos=${includeNodes ? 1 : 0}`
    + flindexConfigRevParam(objetivo_id),
  flindexFetchOpts,
)

export const getFlindexCustom = (user, objetivo_id, node, fecha_inicio, fecha_termino, token, schedule, includeNodes = 0) =>
fetch(
  api_host
    + `/reporte/online/indicadores/getFlindexCustom/?user=${user}&usuarioId=${user}&key=${api_auth}&horarioId=${schedule}&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=${node}&includeNodos=${includeNodes ? 1 : 0}`
    + flindexConfigRevParam(objetivo_id),
  flindexFetchOpts,
)

export const getObjetivoFlindexConfig = (user, objetivo_id, token) =>
fetch(
  api_host
    + `/reporte/online/indicadores/getObjetivoFlindexConfig/?user=${user}&usuarioId=${user}&key=${api_auth}&objetivoId=${objetivo_id}&token=${token}`
    + flindexConfigRevParam(objetivo_id),
  flindexFetchOpts,
)

export const upsertObjetivoFlindexConfig = (user, objetivo_id, indicador, token) =>
fetch(api_host+`/reporte/online/indicadores/upsertObjetivoFlindexConfig/?user=${user}&key=${api_auth}&token=${token}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  cache: 'no-store',
  body: JSON.stringify({
    objetivoId: objetivo_id,
    usuarioId: user,
    indicador,
  }),
})

export const resetObjetivoFlindexConfig = (user, objetivo_id, token) =>
fetch(api_host+`/reporte/online/indicadores/resetObjetivoFlindexConfig/?user=${user}&key=${api_auth}&token=${token}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  cache: 'no-store',
  body: JSON.stringify({
    objetivoId: objetivo_id,
    usuarioId: user,
  }),
})
